if (!window.viraCheckout) {
      (function () {
        var CART_JSON = '/cart.json';
        var YAMPI_CART_API = 'https://api.dooki.com.br/v2/public/shopify/cart';
        var TIMEOUT_MS = 8000;

        var cache = { url: null, sig: null };
        var prefetching = false;
        var busy = false;
        var debounceTimer = null;

        function setAviso(show) {
          var el = document.querySelector('[data-vira-checkout-aviso]');
          if (el) el.hidden = !show;
        }

        function hideYampiLoaderSafe() {
          var loader = document.querySelector('.yampi-loader');
          if (loader) loader.style.display = 'none';
        }

        function setLoading(button, on) {
          if (!button) return;
          if (on) {
            if (!button.dataset.originalLabel) {
              button.dataset.originalLabel = button.textContent.trim();
            }
            var label = button.dataset.loadingLabel;
            if (label) button.textContent = label;
            button.classList.add('is-vira-loading');
            button.setAttribute('aria-busy', 'true');
          } else {
            if (button.dataset.originalLabel) {
              button.textContent = button.dataset.originalLabel;
            }
            button.classList.remove('is-vira-loading');
            button.removeAttribute('aria-busy');
          }
        }

        function signature(cart) {
          if (!cart || !cart.items) return null;
          var lines = cart.items
            .map(function (item) {
              return item.key + 'x' + item.quantity;
            })
            .join(',');
          return cart.item_count + '|' + cart.total_price + '|' + lines;
        }

        function getCart() {
          return fetch(CART_JSON, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          }).then(function (response) {
            return response.json();
          });
        }

        function askYampi(cart) {
          return fetch(YAMPI_CART_API, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              shop: window.location.host,
              cart_payload: cart,
            }),
          }).then(function (response) {
            return response.json();
          });
        }

        function withUtms(url) {
          try {
            return typeof ymp_getUrlWithUtms === 'function' ? ymp_getUrlWithUtms(url) : url;
          } catch (e) {
            return url;
          }
        }

        function clearCache() {
          cache = { url: null, sig: null };
        }

        function prefetch() {
          if (prefetching) return;
          prefetching = true;

          getCart()
            .then(function (cart) {
              if (!cart || !cart.item_count) {
                clearCache();
                return null;
              }
              var sig = signature(cart);
              return askYampi(cart).then(function (resp) {
                if (resp && resp.checkout_direct_url) {
                  cache = { url: resp.checkout_direct_url, sig: sig };
                } else {
                  clearCache();
                }
              });
            })
            .catch(clearCache)
            .then(
              function () {
                prefetching = false;
              },
              function () {
                prefetching = false;
              }
            );
        }

        function schedulePrefetch() {
          clearCache();
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(prefetch, 600);
        }

        window.viraCheckout = function (button) {
          if (busy) return;

          button = button || document.querySelector('[data-vira-checkout-button]');
          setAviso(false);
          busy = true;
          setLoading(button, true);

          function fail() {
            clearTimeout(window.viraCheckoutTimer);
            hideYampiLoaderSafe();
            setLoading(button, false);
            setAviso(true);
            busy = false;
          }

          clearTimeout(window.viraCheckoutTimer);
          window.viraCheckoutTimer = setTimeout(fail, TIMEOUT_MS);

          getCart()
            .then(function (cart) {
              if (!cart || !cart.item_count) throw new Error('carrinho vazio');

              var sig = signature(cart);

              if (cache.url && cache.sig && cache.sig === sig) {
                window.location.href = withUtms(cache.url);
                return null;
              }

              return askYampi(cart).then(function (resp) {
                if (!resp || !resp.checkout_direct_url) throw new Error('sem url de checkout');
                window.location.href = withUtms(resp.checkout_direct_url);
              });
            })
            .catch(fail);
        };

        document.addEventListener('cart:update', schedulePrefetch);
        window.addEventListener('pageshow', schedulePrefetch);

        if (document.readyState === 'complete') {
          schedulePrefetch();
        } else {
          window.addEventListener('load', schedulePrefetch, { once: true });
        }
      })();
    }
